import { AfterViewInit, Component, ElementRef, OnDestroy, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { combineLatest, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ApiService } from '../../services/api.service';
import { UnsubscribeComponent } from '../../generals/Components';
import { CustomerGroupEditor, LabelValue, LabelValueNumber, ProductPriceType, UserGroup } from '../../interfaces/interfaces';

@Component({
    selector: 'app-customergroupeditor',
    templateUrl: './customergroupeditor.component.html',
    styleUrls: ['./customergroupeditor.component.scss']
})
export class CustomergroupeditorComponent extends UnsubscribeComponent implements OnDestroy, AfterViewInit {

    @ViewChild('input') input: ElementRef<HTMLInputElement>;

    customerGroupId: number|null = null;
    customerGroupEditor: CustomerGroupEditor|null = null;
    userGroups: UserGroup[] = [];
    dataLoading = false;
    loading = false;
    customerGroupEditorFormGroup: FormGroup|null = null;
    productPriceTypes: LabelValueNumber[] = [];

    constructor(
        private apiService: ApiService,
        private ref: DynamicDialogRef,
        private config: DynamicDialogConfig
    ) {
        super();
        this.customerGroupId = this.config.data.customerGroupId;
        this.init();
    }

    init(): void {
        this.initCustomerGroupEditorFormGroup();
        this.loadData();
    }

    loadData(): void {
        this.dataLoading = true;
        if (this.customerGroupId !== null) {
            combineLatest([
                this.apiService.getCustomerGroup(this.customerGroupId),
                this.apiService.getSimpleTable<ProductPriceType>('productpricetypes')
            ]).pipe(takeUntil(this.unsubscribe)).subscribe(([{customerGroupEditor}, {data}]) => {
                this.customerGroupEditor = customerGroupEditor;
                this.fillCustomerGroupEditorForm(this.customerGroupEditor);
                this.productPriceTypes = [{label: 'Nincs kiválasztva', value: null}, ...data.map((productPriceType: ProductPriceType) => ({
                    label: productPriceType.name,
                    value: productPriceType.id
                }))];
            }).add(() => {
                this.dataLoading = false;
            });
        } else {
            this.apiService.getSimpleTable<ProductPriceType>('productpricetypes').pipe(takeUntil(this.unsubscribe)).subscribe(({data}) => {
                this.productPriceTypes = [{label: 'Nincs kiválasztva', value: null}, ...data.map((productPriceType: ProductPriceType) => ({
                    label: productPriceType.name,
                    value: productPriceType.id
                }))];
            }).add(() => {
                this.dataLoading = false;
            });
        }
    }

    initCustomerGroupEditorFormGroup(): void {
        this.customerGroupEditorFormGroup = new FormGroup({
            name: new FormControl('', [Validators.required]),
            priceId: new FormControl(null, [Validators.required]),
            isDefault: new FormControl(false)
        });
    }

    fillCustomerGroupEditorForm(customerGroupEditor: CustomerGroupEditor): void {
        this.customerGroupEditorFormGroup.get('name').setValue(customerGroupEditor.name);
        this.customerGroupEditorFormGroup.get('priceId').setValue(customerGroupEditor.priceId);
        this.customerGroupEditorFormGroup.get('isDefault').setValue(customerGroupEditor.isDefault);
    }

    save(): void {
        if (this.customerGroupEditorFormGroup.invalid) {
            return;
        }
        this.loading = true;
        const userEditorFormValue: any = this.customerGroupEditorFormGroup.value;
        if (this.customerGroupId === null) {
            this.apiService.createCustomerGroup(userEditorFormValue).pipe(takeUntil(this.unsubscribe)).subscribe(() => {
                this.ref.close(true);
            }).add(() => {
                this.loading = false;
            });
        } else {
            this.apiService.updateCustomerGroup(this.customerGroupId, userEditorFormValue).pipe(
                takeUntil(this.unsubscribe)
            ).subscribe(() => {
                this.ref.close(true);
            }).add(() => {
                this.loading = false;
            });
        }
    }

    close(result: boolean = false): void {
        this.ref.close(result);
    }

    ngAfterViewInit(): void {
        this.input.nativeElement.focus();
    }
}
